<template lang="pug">
el-table.fileView(v-if="files.length > 0" :data="files" :show-header="false" max-height="200px")
  el-table-column(label="名称" v-slot="{row}")
    .labelList
      img(:src="className(row)")
      .title(@click="preview(row)") {{row.fileName}}
  el-table-column(label="操作"  width="60px" v-slot="{row}")
    i.el-icon-download(title="下载" @click="downLoadFile(row)" )
    i.el-icon-delete(title="删除" v-if="!noDelete" @click="deleteRow(row)")
</template>

<script>
import { tableRowIcon, filePreviewV1 } from "@/CommonDP/utils/docPublic";
import { downloadUrltoken, downloadFile } from "@/CommonDP/utils/index";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
export default {
  props: {
    files: { type: Array, default: () => [] },
    noDelete: { type: Boolean, default: false },
    uuid: { type: String, default: "" }
  },
  data () {
    return {

    };
  },
  computed: {
    flowInstanceId() {
      return getApprove(this.uuid)?.getMessage()?.flowInstanceId || "";
    }
  },
  methods: {
    className(row) {
      return tableRowIcon(row);
    },
    preview(row) {
      const data = {
        fileType: row.fileType,
        fileId: row.fileId,
        versionId: row.versionIds || row.fileVersion,
        flowInstanceId: this.flowInstanceId,
        status: row.status,
        parentId: row.parentId
      };
      filePreviewV1(row, data);
    },
    downLoadFile(row) {
      const fileId = row.fileId;
      const url = downloadUrltoken("EnterpriseDoc", fileId);
      downloadFile(url);
    },
    deleteRow(row) {
      this.$confirm(`您确定删除已经上传的${row.fileName}文件嘛`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.$emit("deleteFiles", row);
      }).catch((error) => {
        console.log(error);
      });
    }
  }

};
</script>

<style lang="scss" scoped>
.fileView{
  margin-top: 10px;
}
.labelList{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  img{
    width: 22px;
    height: 22px;
  }
  .title{
    margin-left: 5px;
    cursor: pointer;
    font-size: 14px;
  }
}
.el-icon-download{
  font-size: 16px;
  color: var(--theme-color);
  cursor: pointer;
}
.el-icon-delete{
  margin-left: 5px;
  font-size: 16px;
  color: #f54f45;
  cursor: pointer;
}
</style>
